import { SITE } from '@/constants';

export default function WhatsAppButton() {
  return (
    <a
      href={SITE.whatsappLink}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      title="Cotizar proyecto por WhatsApp"
      className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-black text-white flex items-center justify-center hover:bg-neutral-800 transition-colors"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}